import {Component, HostListener, Inject, Input, ViewChild} from '@angular/core';
import {
  ApplicationFormSettings,
  Competitor,
  CompetitorFilter,
  CompetitorStatus,
  EventItem,
  Lookups,
  PagedFilter,
  Pages,
  Race,
  RaceSettings
} from "@model";
import {DOCUMENT} from '@angular/common';
import {PanelComponent, AbstractComponent, FileType} from '@components';
import {ActivatedRoute, Router} from '@angular/router';
import {REGISTER_TO_RACE} from "../../../../../../app-routing.module";
import {ExportService} from '@services';

@Component({
  selector: 'app-race-competitors-list-component',
  templateUrl: './race-competitors-list-component.component.html',
  styleUrls: ['./race-competitors-list-component.component.scss']
})
export class RaceCompetitorsListComponentComponent extends AbstractComponent {
  @Input() competitors: Competitor[] = [];
  @Input() race: Race | undefined;
  @Input() eventItem: EventItem | undefined;
  @Input() genders: Lookups[] = [];
  @Input({required: true}) languages: Lookups[] = [];
  @Input() raceSettings: RaceSettings | undefined;
  @Input() applicationFormSettings: ApplicationFormSettings | undefined;
  @ViewChild("importPanel") importPanel?: PanelComponent;

  showFabButton: boolean = false;
  selectedFile: string | undefined;
  importType: ImportType = ImportType.APPEND;
  importTypes: ImportType[] = [ImportType.APPEND, ImportType.MERGE, ImportType.OVERWRITE]
  filter: PagedFilter<CompetitorFilter> | undefined;
  category: number | undefined = undefined;
  name: string | undefined;
  gender: number | undefined = undefined;
  selectedStatus: CompetitorStatus | undefined;
  page: number = 1;


  competitorStatuses: CompetitorStatus[] = [CompetitorStatus.REG, CompetitorStatus.BIB, CompetitorStatus.RDY,
    CompetitorStatus.STA, CompetitorStatus.FIN, CompetitorStatus.DSQ, CompetitorStatus.DNF, CompetitorStatus.TLE, CompetitorStatus.DNS];

  constructor(@Inject(DOCUMENT) private document: Document,
              private route: ActivatedRoute, private router: Router, private exportService: ExportService) {
    super();
  }

  handleFilterChange(filter: PagedFilter<CompetitorFilter> | undefined): void {
    this.filter = filter;
  }

  @HostListener('window:scroll')
  toggleFabButton(): void {
    this.showFabButton = window.pageYOffset != 0;
  }

  competitorFileAdded(file: string | undefined) {
    this.selectedFile = file;
  }

  downloadTemplate() {
    //todo
  }

  onRegister() {
    this.router.navigate([REGISTER_TO_RACE], {
      relativeTo: this.route,
      queryParams: {
        eventId: this.eventItem!.id,
        raceId: this.eventItem!.racesList![0].id
      }
    });
  }

  isRaceRegistrationEnabled() {
    return (!!this.race?.raceRegistrationEnabled);
  }

  importCompetitorList() {
    //todo
  }

  exportCompetitorList(type: string) {
    if (this.filter === undefined || !this.filter || this.filter === null) {
      let filter: CompetitorFilter = new CompetitorFilter();
      if (this.category) {
        filter.categories = [this.category];
      }
      filter.gender = this.gender ?? undefined;
      filter.name = this.name;
      filter.eventId = +this.route.snapshot.queryParams['eventId'],
        filter.raceId = +this.route.snapshot.queryParams['raceId'];
      this.filter = new PagedFilter(new Pages(undefined, this.page), filter);
    }
    this.exportService.downloadCompetitorsListForRaceFile(type, this.filter).subscribe(
      (blob: Blob) => {
        const formattedDateTime = this.getCurrentDateTimeFormatted();
        const filename = type + '_' + formattedDateTime + '.' + type;
        const downloadLink = this.document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.setAttribute('download', filename);
        this.document.body.appendChild(downloadLink);
        downloadLink.click();
      },
      error => {
        console.error('Error downloading file:', error);
      }
    );
  }

  getCurrentDateTimeFormatted(): string {
    const currentDateTime = new Date();
    const year = currentDateTime.getFullYear();
    const month = this.padNumber(currentDateTime.getMonth() + 1, 2);
    const day = this.padNumber(currentDateTime.getDate(), 2);
    return `${year}-${month}-${day}`;
  }

  padNumber(num: number, size: number): string {
    let numStr = num.toString();
    while (numStr.length < size) {
      numStr = '0' + numStr;
    }
    return numStr;
  }

  assignBibs() {
    //todo
  }

  trackByFn(index: number, item: Competitor): number | undefined {
    return item.id;
  }

  scrollToTop(): void {
    return this.document.body.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'start'
    });
  }

  onImportTypeChange(type: ImportType) {
    this.importType = type;
  }

  initImportParams() {
    this.selectedFile = undefined;
    this.importType = ImportType.APPEND
  }

  onImportPanelCancel() {
    this.selectedFile = undefined;
    this.importType = ImportType.APPEND
    this.importPanel?.closeDropdown()
  }

  onImportPanelSave() {
    //todo
  }

  protected readonly FileType = FileType;
}

export enum ImportType {
  OVERWRITE = 1,
  APPEND = 2,
  MERGE = 3
}
